export const NAV = {
  wordmark: "nav-wordmark",
  linkWork: "nav-link-work",
  linkStudio: "nav-link-studio",
  linkAiFilms: "nav-link-ai-films",
  linkContact: "nav-link-contact",
  linkInstagramTrial: "nav-link-instagram-trial",
};

export const VIEW_SWITCH = {
  slider: "view-switch-slider",
  grid: "view-switch-grid",
  list: "view-switch-list",
};

export const FILTERS = {
  searchInput: "filter-search-input",
  categoryAll: "filter-pill-category-all",
  categoryPill: (cat) => `filter-pill-category-${String(cat).toLowerCase()}`,
  typePill: (type) => `filter-pill-type-${String(type).toLowerCase().replace(/\s+/g, "-")}`,
  clearAll: "filter-clear-all",
};

export const FILMSTRIP = {
  container: "filmstrip-container",
  panel: (i) => `filmstrip-panel-${i}`,
  prevArrow: "filmstrip-prev-arrow",
  nextArrow: "filmstrip-next-arrow",
};

export const GRID = {
  container: "grid-container",
  card: (slug) => `grid-card-${slug}`,
};

export const LIST = {
  container: "list-container",
  row: (slug) => `list-row-${slug}`,
};

export const VIDEO_PLAYER = {
  container: "video-player-container",
  playButton: "video-play-button",
  muteButton: "video-mute-button",
  fullscreenButton: "video-fullscreen-button",
  nativeVideo: "video-native-element",
  unavailable: "video-unavailable-state",
};

export const PROJECT_DETAIL = {
  backButton: "project-back-to-work",
  nextButton: "project-next-project",
  title: "project-title",
  demoBadge: (slug) => `project-demo-badge-${slug}`,
  relatedCard: (slug) => `project-related-card-${slug}`,
};

export const CONTACT = {
  nameInput: "contact-name-input",
  emailInput: "contact-email-input",
  typeSelect: "contact-type-select",
  messageInput: "contact-message-input",
  submitButton: "contact-submit-button",
  statusMessage: "contact-status-message",
};

export const BANNER = {
  demoBanner: "demo-preview-banner",
  dismiss: "demo-preview-banner-dismiss",
};

export const TRIAL = {
  page: "instagram-trial-page",
  detailPage: "instagram-trial-detail-page",
  grid: "trial-grid",
  card: (code) => `trial-card-${code}`,
  backButton: "trial-back-button",
  nextButton: "trial-next-button",
  externalLink: "trial-external-link",
};

export const IG_EMBED = {
  container: "ig-embed-container",
  loading: "ig-embed-loading",
  unavailable: "ig-embed-unavailable",
  retry: "ig-embed-retry",
  externalLink: "ig-embed-external-link",
};

export const WORK = {
  page: "work-catalog-page",
  searchInput: "work-search-input",
  categorySelect: "work-category-select",
  accountSelect: "work-account-select",
  aiToggle: "work-ai-toggle",
  yearFromSelect: "work-year-from-select",
  yearToSelect: "work-year-to-select",
  clearAll: "work-clear-all",
  resultCount: "work-result-count",
  sortSelect: "work-sort-select",
  emptyState: "work-empty-state",
  groupSection: (key) => `work-group-${key}`,
  loadingState: "work-loading-state",
  errorState: "work-error-state",
  prevPage: "work-prev-page",
  nextPage: "work-next-page",
  pageInfo: "work-page-info",
};

export const WORK_DETAIL = {
  page: "work-detail-page",
  backButton: "work-detail-back",
  nextButton: "work-detail-next",
  brandTitle: "work-detail-brand-title",
  category: "work-detail-category",
  caption: "work-detail-caption",
  videoAbout: "work-detail-video-about",
  keywords: "work-detail-keywords",
  aiBadge: "work-detail-ai-badge",
  coverPendingBadge: "work-detail-cover-pending-badge",
  notFound: "work-detail-not-found",
  externalLink: "work-detail-external-link",
};

